import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	templateInfoMessage: {
		id: 'polaris-ideas.right-sidebar.idea-templates.common.template-modal.template-info-message',
		defaultMessage: 'Applying a template will not delete your idea’s description',
		description: 'Modal dialog info message for template applying',
	},
});
